import { RunExecution } from "@features/executions/run-execution/domain/interfaces";

export interface RunExecutionStateModel {
	run: RunExecution;
}

export const runExecutionStateDefaults = {
	run: null,
};
